import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "CommonTemplate" */ './Common'), {
    fallback: null,
});
